export const environment = {
  production: false,
  apiUrl: 'https://dev.polpaico.appmaestro.api-gateway.innovaweb.cl/core/graphql',
  restUrl: 'https://dev.polpaico.appmaestro.api-gateway.innovaweb.cl/core/api',
  storage: 'azure',
}
